module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"label":"Password"},"fr_FR":{"label":"Mot de passe"}}')
  delete Component.options._Ctor
}
